import { motion } from "framer-motion";

const base = "pointer-events-none absolute select-none";

function Ghost({ className = "", width, height, viewBox, children }) {
  return (
    <motion.div
      className={`${base} ${className}`}
      initial={{ opacity: 0.35, scale: 1.04 }}
      whileInView={{ opacity: 1, scale: 1 }}
      viewport={{ once: false, amount: 0.2 }}
      transition={{ duration: 1.6, ease: [0.16, 1, 0.3, 1] }}
      aria-hidden="true"
    >
      <svg width={width} height={height} viewBox={viewBox} fill="none">
        {children}
      </svg>
    </motion.div>
  );
}

export const GhostRings = ({ className = "" }) => (
  <Ghost className={className} width="560" height="560" viewBox="0 0 560 560">
    {[70, 130, 190, 250].map((r) => (
      <circle
        key={r}
        cx="280"
        cy="280"
        r={r}
        stroke="currentColor"
        strokeWidth="1"
        strokeDasharray={r === 190 ? "4 10" : undefined}
      />
    ))}
    <circle cx="280" cy="280" r="4" fill="currentColor" />
  </Ghost>
);

export const GhostGrid = ({ className = "" }) => (
  <Ghost className={className} width="640" height="640" viewBox="0 0 640 640">
    {Array.from({ length: 9 }, (_, i) => (
      <line key={`v${i}`} x1={i * 80} y1="0" x2={i * 80} y2="640" stroke="currentColor" strokeWidth="1" />
    ))}
    {Array.from({ length: 9 }, (_, i) => (
      <line key={`h${i}`} x1="0" y1={i * 80} x2="640" y2={i * 80} stroke="currentColor" strokeWidth="1" />
    ))}
    <circle cx="400" cy="240" r="120" stroke="currentColor" strokeWidth="1" strokeDasharray="4 10" />
  </Ghost>
);

export const GhostTrend = ({ className = "" }) => (
  <Ghost className={className} width="720" height="420" viewBox="0 0 720 420">
    <path d="M20 380 L160 300 L260 330 L400 200 L500 230 L640 60" stroke="currentColor" strokeWidth="2" />
    <path d="M560 60 L640 60 L640 140" stroke="currentColor" strokeWidth="2" />
    {[[160, 300], [260, 330], [400, 200], [500, 230]].map(([x, y], i) => (
      <circle key={i} cx={x} cy={y} r="5" stroke="currentColor" strokeWidth="1.5" />
    ))}
  </Ghost>
);

export const GhostQuote = ({ className = "" }) => (
  <Ghost className={className} width="360" height="280" viewBox="0 0 360 280">
    <path d="M40 200 Q40 80 140 60 L140 110 Q90 125 88 165 L140 165 L140 240 L40 240 Z" stroke="currentColor" strokeWidth="2" />
    <path d="M210 200 Q210 80 310 60 L310 110 Q260 125 258 165 L310 165 L310 240 L210 240 Z" stroke="currentColor" strokeWidth="2" />
  </Ghost>
);

export const GhostScan = ({ className = "" }) => (
  <Ghost className={className} width="420" height="420" viewBox="0 0 420 420">
    <path d="M20 100 V20 H100" stroke="currentColor" strokeWidth="2" />
    <path d="M320 20 H400 V100" stroke="currentColor" strokeWidth="2" />
    <path d="M400 320 V400 H320" stroke="currentColor" strokeWidth="2" />
    <path d="M100 400 H20 V320" stroke="currentColor" strokeWidth="2" />
    <circle cx="210" cy="210" r="90" stroke="currentColor" strokeWidth="1" strokeDasharray="4 10" />
    <line x1="210" y1="150" x2="210" y2="270" stroke="currentColor" strokeWidth="1" />
    <line x1="150" y1="210" x2="270" y2="210" stroke="currentColor" strokeWidth="1" />
  </Ghost>
);

export const GhostCalendar = ({ className = "" }) => (
  <Ghost className={className} width="480" height="420" viewBox="0 0 480 420">
    <rect x="30" y="60" width="420" height="330" rx="24" stroke="currentColor" strokeWidth="2" />
    <line x1="30" y1="130" x2="450" y2="130" stroke="currentColor" strokeWidth="2" />
    <line x1="120" y1="60" x2="120" y2="100" stroke="currentColor" strokeWidth="2" />
    <line x1="360" y1="60" x2="360" y2="100" stroke="currentColor" strokeWidth="2" />
    {[0, 1, 2].map((r) =>
      [0, 1, 2, 3].map((c) => (
        <rect
          key={`${r}${c}`}
          x={62 + c * 96}
          y={158 + r * 72}
          width="56"
          height="44"
          rx="10"
          stroke="currentColor"
          strokeWidth="1"
          strokeDasharray={(r + c) % 3 === 0 ? "4 8" : undefined}
        />
      ))
    )}
  </Ghost>
);

export const GhostWaves = ({ className = "" }) => (
  <Ghost className={className} width="640" height="400" viewBox="0 0 640 400">
    <path d="M0 200 Q80 140 160 200 T320 200 T480 200 T640 200" stroke="currentColor" strokeWidth="1.5" />
    <path d="M0 260 Q80 200 160 260 T320 260 T480 260 T640 260" stroke="currentColor" strokeWidth="1.5" />
    <path d="M0 140 Q80 80 160 140 T320 140 T480 140 T640 140" stroke="currentColor" strokeWidth="1.5" />
  </Ghost>
);
